import React, { useContext, useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { CustomText } from '@/components/CustomText';
import { Text } from 'react95-native-rabbl';
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { Image, ImageSource, ImageStyle } from 'expo-image';

const styles = StyleSheet.create({
  w31h12: { width: 31, height: 12 },
  w27h11: { width: 27, height: 11 },
  w28h14: { width: 28, height: 14 },
  w30h14: { width: 30, height: 14 },
  w28h10: { width: 28, height: 10 },
  w40h10: { width: 40, height: 10 },
  w29h12: { width: 29, height: 12 },
  w24h10: { width: 24, height: 10 },
  w18h13: { width: 18, height: 13 },
  w32h16: { width: 28, height: 14 },
  w41h20: { width: 28, height: 14 },
  w22h17: { width: 32, height: 16 },
  w28h11: { width: 41, height: 20 },
  w31h15: { width: 31, height: 15 },
  w33h11: { width: 33, height: 11 },
  w29h13: { width: 29, height: 13 },
  w20h12: { width: 20, height: 12 },
  w26h16: { width: 26, height: 16 },
});

type Props = {
  id?: number,
};

type ImageInfo = {
  source: ImageSource,
  style: ImageStyle,
};

function getRandomIntInclusive(min: number, max: number): number {
  const minCeiled: number = Math.ceil(min);
  const maxFloored: number = Math.floor(max);
  return Math.floor(Math.random() * (maxFloored - minCeiled + 1)) + minCeiled;
}

const MAX_ID = 21;

const images = new Map<number, ImageInfo>([
  [1, { source: require('@/assets/images/new2.gif'), style: styles.w31h12 }],
  [2, { source: require('@/assets/images/new3.gif'), style: styles.w27h11 }],
  [3, { source: require('@/assets/images/new4.gif'), style: styles.w28h14 }],
  [4, { source: require('@/assets/images/new5.gif'), style: styles.w30h14 }],
  [5, { source: require('@/assets/images/new6.gif'), style: styles.w28h10 }],
  [6, { source: require('@/assets/images/new7.gif'), style: styles.w40h10 }],
  [7, { source: require('@/assets/images/new8.gif'), style: styles.w29h12 }],
  [8, { source: require('@/assets/images/new10.gif'), style: styles.w24h10 }],
  [9, { source: require('@/assets/images/new12.gif'), style: styles.w18h13 }],
  [10, { source: require('@/assets/images/new13.gif'), style: styles.w28h14 }],
  [11, { source: require('@/assets/images/new14.gif'), style: styles.w28h14 }],
  [12, { source: require('@/assets/images/new15.gif'), style: styles.w32h16 }],
  [13, { source: require('@/assets/images/new18.gif'), style: styles.w41h20 }],
  [14, { source: require('@/assets/images/new19.gif'), style: styles.w22h17 }],
  [15, { source: require('@/assets/images/new20.gif'), style: styles.w28h11 }],
  [16, { source: require('@/assets/images/new21.gif'), style: styles.w31h15 }],
  [17, { source: require('@/assets/images/new22.gif'), style: styles.w33h11 }],
  [18, { source: require('@/assets/images/new23.gif'), style: styles.w29h13 }],
  [19, { source: require('@/assets/images/new25.gif'), style: styles.w20h12 }],
  [20, { source: require('@/assets/images/new26.gif'), style: styles.w26h16 }],
  [MAX_ID, { source: require('@/assets/images/new27.gif'), style: styles.w24h10 }],
]);

export default function Bullet({ id = -1 }: Props) : React.ReactNode {
  if (id == -1) {
    id = getRandomIntInclusive(1, MAX_ID);
  }
  return <Image source={images.get(id)?.source} style={images.get(id)?.style} />;
};
